var map = {
	"./css/common.css": "erWL",
	"./css/font/RWmMoKWR9v4ksMfaWd_JN9XFiaQ.woff2": "OlEv",
	"./css/font/RWmMoKWR9v4ksMfaWd_JN9XLiaQ6DQ.woff2": "L0VX",
	"./css/vietnamese.css": "NN4m",
	"./fonts/Skia.ttf": "CUoa",
	"./fonts/woff2/PingFangSCBold.woff2": "IcgD",
	"./fonts/woff2/PingFangSCExtraLight.woff2": "YvnW",
	"./fonts/woff2/PingFangSCHeavy.woff2": "CqU5",
	"./fonts/woff2/PingFangSCLight.woff2": "oB5/",
	"./fonts/woff2/PingFangSCMedium.woff2": "0tga",
	"./fonts/woff2/PingFangSCRegular.woff2": "GKWp",
	"./fonts/woff2/Skia-Regular.woff2": "4O24",
	"./image/about/about-company.png": "L7kE",
	"./image/about/about.png": "EeLt",
	"./image/about/address.png": "cXt1",
	"./image/about/case-item.png": "Zuvu",
	"./image/about/coll-bg.png": "VInO",
	"./image/about/contact-bg.png": "MZlw",
	"./image/about/developmentBg.png": "Cl+H",
	"./image/about/email.png": "jelJ",
	"./image/about/inv.png": "pomf",
	"./image/about/logo.png": "7PyK",
	"./image/about/logo10.png": "ktKa",
	"./image/about/logo11.png": "4vEd",
	"./image/about/logo12.png": "Ro3H",
	"./image/about/logo13.png": "Epnq",
	"./image/about/logo14.png": "PeCU",
	"./image/about/logo15.png": "QPet",
	"./image/about/logo16.png": "p/Qn",
	"./image/about/logo17.png": "fefg",
	"./image/about/logo18.png": "g+ey",
	"./image/about/logo19.png": "ABIz",
	"./image/about/logo2.png": "NXXV",
	"./image/about/logo20.png": "oDdh",
	"./image/about/logo21.png": "Fi6+",
	"./image/about/logo22.png": "wcq+",
	"./image/about/logo23.png": "2Bc8",
	"./image/about/logo24.png": "7+f2",
	"./image/about/logo25.png": "b4Mi",
	"./image/about/logo26.png": "uxtb",
	"./image/about/logo3.png": "vdCK",
	"./image/about/logo4.png": "cRtg",
	"./image/about/logo5.png": "JWT8",
	"./image/about/logo6.png": "GqWu",
	"./image/about/logo7.png": "yjfA",
	"./image/about/logo8.png": "kT/r",
	"./image/about/logo9.png": "crVA",
	"./image/about/map-icon.png": "MQEk",
	"./image/about/partner.png": "iOmC",
	"./image/about/qua-bg.png": "qh8n",
	"./image/about/qua.png": "XuRw",
	"./image/about/school1.png": "36K/",
	"./image/about/stepBtn.png": "BlLM",
	"./image/about/stepBtnHover.png": "zANB",
	"./image/about/talent-bg.png": "fnoP",
	"./image/about/tel.png": "6648",
	"./image/beian.png": "X4ev",
	"./image/footer-address.png": "Ana6",
	"./image/footer-email.png": "39EG",
	"./image/footer-tel.png": "8p1i",
	"./image/header-mobile.png": "xCIh",
	"./image/header-x.png": "kuLD",
	"./image/index/astronaut1.png": "YPK1",
	"./image/index/astronaut2.png": "9/l4",
	"./image/index/bannerX.png": "r/ts",
	"./image/index/headerMenuX.png": "L9FM",
	"./image/index/index-new-bg.png": "rOkd",
	"./image/index/index-partner-bg.png": "MFgy",
	"./image/index/index-product-ap.png": "Out6",
	"./image/index/index-product-bg.png": "DZ4B",
	"./image/index/index-product-detail.png": "GJNA",
	"./image/index/index-product-guangwang.png": "dlaf",
	"./image/index/index-product-gw.png": "mrdb",
	"./image/index/index-product-platform.png": "RE1A",
	"./image/index/index-product-sj.png": "pc53",
	"./image/index/index-product-sw.png": "zfHr",
	"./image/index/index-product-system.png": "bqtu",
	"./image/index/index-solution-bg.png": "7QOj",
	"./image/index/index_about_us.png": "fiab",
	"./image/index/index_x1.png": "CKeq",
	"./image/index/logo.png": "gb2U",
	"./image/index/new.png": "jynK",
	"./image/index/new1.png": "noiG",
	"./image/index/pathIcon.png": "Hmza",
	"./image/index/product-operation.png": "TRPp",
	"./image/index/soluteImage1.jpg": "UAl+",
	"./image/index/soluteImage2.jpg": "M9w3",
	"./image/index/soluteImage3.jpg": "BnVk",
	"./image/index/solution-factory.png": "IwOT",
	"./image/index/solution-school.png": "vXEF",
	"./image/index/solution-wifi.png": "J7hS",
	"./image/index/wx-public.jpg": "rfQc",
	"./image/logo.png": "KItN",
	"./image/news/banbg.png": "Y0r6",
	"./image/news/jt_left.png": "L77I",
	"./image/news/jt_right.png": "mgeM",
	"./image/news/n1.png": "33HB",
	"./image/news/n10.jpg": "igNT",
	"./image/news/n2.png": "jFXA",
	"./image/news/n3.png": "oB5p",
	"./image/news/n5.png": "aBJb",
	"./image/news/n6.png": "KIcs",
	"./image/news/n7.jpg": "un0/",
	"./image/news/n8.jpg": "Hesl",
	"./image/news/n9.jpg": "Gs2+",
	"./image/news/news-author.png": "keIC",
	"./image/news/news-back-list.png": "5y0V",
	"./image/news/news-title1.png": "Ddg/",
	"./image/news/news1.png": "fWeY",
	"./image/news/news11.jpg": "NOtL",
	"./image/news/news12.jpg": "6d5u",
	"./image/news/news2.png": "8tXV",
	"./image/news/news3.png": "X49C",
	"./image/news/news4.png": "Obj1",
	"./image/news/news5.png": "fWOU",
	"./image/news/timebg.png": "SGnu",
	"./image/partner/bannerBg.png": "QH6s",
	"./image/partner/case-byd.png": "mvXm",
	"./image/partner/case-fsk.png": "bXJc",
	"./image/partner/case-hs.jpg": "RIQi",
	"./image/partner/case-klgs.jpg": "LuSu",
	"./image/partner/case-lx.png": "8pkL",
	"./image/partner/case-rb.jpg": "28Uq",
	"./image/partner/case1.png": "I9rz",
	"./image/partner/case2.png": "7zAc",
	"./image/partner/case3.png": "uq4d",
	"./image/partner/case4.png": "UFxB",
	"./image/partner/case5.png": "/ra0",
	"./image/partner/case6.png": "U/NO",
	"./image/partner/case7.png": "yPrz",
	"./image/partner/case8.png": "7Mfo",
	"./image/partner/case9.jpg": "atsX",
	"./image/partner/detail-type-checked.png": "b+ak",
	"./image/partner/detail-type.png": "Bkd4",
	"./image/partner/typeBg.png": "vGpk",
	"./image/product/icon-left.png": "AKIJ",
	"./image/product/product-ap.png": "Jlu2",
	"./image/product/product-bg.png": "coB8",
	"./image/product/product-crm.png": "uqxK",
	"./image/product/product-dzbp.png": "Ag14",
	"./image/product/product-gap.png": "YO16",
	"./image/product/product-gw.png": "NnTH",
	"./image/product/product-item-bg.png": "ODJr",
	"./image/product/product-jfrz.png": "UjZj",
	"./image/product/product-jwzw.png": "HFrU",
	"./image/product/product-jxc.png": "qabr",
	"./image/product/product-kfxt.png": "g9Az",
	"./image/product/product-mdu.png": "ka5Z",
	"./image/product/product-odn.png": "citK",
	"./image/product/product-olt.png": "WPKH",
	"./image/product/product-qlbj.png": "Np0L",
	"./image/product/product-rlmj.png": "cLQX",
	"./image/product/product-shsd.png": "fdLW",
	"./image/product/product-shzn.png": "ae9+",
	"./image/product/product-sjxt.png": "7Oa7",
	"./image/product/product-sw.png": "Apcf",
	"./image/product/product-swgk.png": "X3xA",
	"./image/product/product-tdzj.png": "JUl8",
	"./image/product/product-wgxt.png": "ELey",
	"./image/product/product-xyaqxt.png": "+35Y",
	"./image/product/product-xysh.png": "gOSR",
	"./image/product/product-yyzt.png": "JWqp",
	"./image/product/product-zndj.png": "nIXj",
	"./image/product/product-znyy.png": "kEnJ",
	"./image/product/product-zzxy.png": "fY34",
	"./image/product/yygd.png": "C1sy",
	"./image/slide-code.png": "LZ8A",
	"./image/slide-lemon.png": "2CQ6",
	"./image/slide-mobile.png": "VUCk",
	"./image/slide-top.png": "VYTx",
	"./image/solution/detail-list-bg.png": "ElFE",
	"./image/solution/detail-one1.png": "C8gK",
	"./image/solution/detail-one2.png": "HZf1",
	"./image/solution/detail-one3.png": "kiJN",
	"./image/solution/detail-one4.png": "GT16",
	"./image/solution/detail-self1.png": "k9Id",
	"./image/solution/detail-self2.png": "XTSf",
	"./image/solution/detail-self3.png": "qGFV",
	"./image/solution/detail-self4.png": "4wRz",
	"./image/solution/detail-two-bg.png": "7mqa",
	"./image/solution/detail-two1.png": "tRsx",
	"./image/solution/detail.png": "eM8B",
	"./image/solution/factory_icon.png": "7gn1",
	"./image/solution/school_icon.png": "iRbf",
	"./image/solution/solution-bg.png": "iY6+",
	"./image/solution/solution-detail-bg.png": "YeZ/",
	"./image/solution/solution-factory.png": "Dc+d",
	"./image/solution/solution-four-more-hover.png": "9flE",
	"./image/solution/solution-four-more.png": "GDvX",
	"./image/solution/solution-gongdi.png": "jREi",
	"./image/solution/solution-more.png": "SGnU",
	"./image/solution/solution-school.png": "ni9L",
	"./image/solution/solution-smart-factory1.png": "a+Cg",
	"./image/solution/solution-smart-fatory.png": "bXMT",
	"./image/solution/solution-smart-school.png": "fXIA",
	"./image/solution/solution-smart-school1.png": "wwfN",
	"./image/solution/solution-wx-zz.png": "ujEI",
	"./image/solution/value-bg.png": "nGCx",
	"./image/solution/wifi-icon.png": "qa66",
	"./image/test/circle1.png": "iKrq",
	"./image/test/circle2.png": "rfk/",
	"./image/xplan/analysisBg1.png": "R1PH",
	"./image/xplan/analysisText.png": "Gn1x",
	"./image/xplan/case1.png": "fcjf",
	"./image/xplan/case2.png": "IRkB",
	"./image/xplan/case3.png": "JVxh",
	"./image/xplan/case4.png": "WKm5",
	"./image/xplan/feedbackBg.png": "roih",
	"./image/xplan/feedbackIcon1.png": "xCUg",
	"./image/xplan/first.png": "An45",
	"./image/xplan/money-first.png": "wTbc",
	"./image/xplan/money-second.png": "++r1",
	"./image/xplan/money-three.png": "uHx7",
	"./image/xplan/money.png": "z42X",
	"./image/xplan/money1.png": "IDky",
	"./image/xplan/money2.png": "AVtO",
	"./image/xplan/trusteeship-bg.png": "dhzd",
	"./image/xplan/trusteeship-con.png": "YPZP",
	"./image/xplan/trusteeship1.png": "qKx6",
	"./image/xplan/trusteeship2.png": "tcq+",
	"./image/xplan/trusteeship3.png": "HzBF",
	"./image/xplan/trusteeship4.png": "8SZy",
	"./image/xplan/trusteeship5.png": "iGAu",
	"./image/xplan/trusteeship6.png": "eerp",
	"./image/xplan/trusteeshipBg.png": "zE3p",
	"./image/xplan/trusteeshipText.png": "LkQ1",
	"./image/xplan/x-cases.png": "HxBS",
	"./image/xplan/x-desc.png": "beT5",
	"./image/xplan/xPartner-bg.png": "7nDQ",
	"./image/xplan/xPartner1.png": "+GEe",
	"./image/xplan/xPartner2.png": "ph+1",
	"./image/xplan/xPartner3.png": "Z96X"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "PvXa";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*$
// module id = PvXa
// module chunks = 0